module.exports = __webpack_public_path__ + "media/select_007.3b73f3cd.ogg";